import * as actionTypes from "./action-types"

const initialState={
    score:0,
    isQuiz:false,
    showNav:false
}

export const reducer=( state=initialState, action )=>{
    switch(action.type){
        case actionTypes.TOTALSCORE:
            return{
                ...state,
                score:state.score +1
            }
            case actionTypes.CONTENTAFTERLOGIN:
                return{
                    ...state,
                    showNav:true
                }
                case actionTypes.AFTERLOGOUT:
                    return{
                        ...state,
                        showNav:false
                    }



            default:
                return state;
    }

}